import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../BaseUrl/baseurl";
import http from "../BaseUrl/baseurl";
import axios from "axios";
const token = localStorage.getItem("token");

export const getPropertyList = createAsyncThunk("getPropertyList", async id => {
    let response;
    try {
        response = await axios.get(`${baseUrl}/property/getallproperty/${1}`, {
            headers: {
                authorization: token
            }
        });
    } catch (error) {
        console.log("getPropertyList", error);
        return [];
    }
    console.log("I am response from property list", response.data);
    return response.data;
});

export const getPropertybyId = createAsyncThunk("getPropertybyId", async id => {
    const response = await axios.get(`${baseUrl}/property/${id}`, {
        headers: {
            authorization: token
        }
    });
    console.log("propertybyidResponse", response.data);
    return response.data;
});

const PropertyListingSlice = createSlice({
    name: "propertylisting",

    initialState: {
        property: [],
        propertyListingList: [],
        currentPage: 1,
        totalPages: 0,
        filteredProperties: [],
        status: "",
        error: ""
    },
    reducers: {
        setFilteredProperties: (state, action) => {
            console.log("I am filtered properties", action.payload);
            state.filteredProperties = action.payload;
        }
    },

    extraReducers(builder) {
        // add seller
        builder
            .addCase(getPropertyList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getPropertyList.fulfilled, (state, action) => {
                console.log(
                    "I am action.payload for property listing",
                    action.payload.data
                );
                state.status = "succeeded";
                state.propertyListingList = action.payload.data;
                state.currentPage = action.payload.currentPage;
                state.totalPages = action.payload.totalPages;
            })
            .addCase(getPropertyList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(getPropertybyId.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getPropertybyId.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.property = action.payload;
            })
            .addCase(getPropertybyId.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
});

export const { setFilteredProperties } = PropertyListingSlice.actions;
export default PropertyListingSlice.reducer;
